import { InjectionToken } from "@angular/core";

import { AdvertisementFacade } from "./advertisement.facade";

export const ADVERTISEMENT_FACADE =
  new InjectionToken<AdvertisementFacade>('ADVERTISEMENT_FACADE');